
<form>
    <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate-pulse" [fullScreen] = "true"><p style="color: white" > Processing... </p></ngx-spinner>
    <div class="card">
        <div class="card-header bg-primary text-left text-white font-weight-bold">
            SPRA Request Data
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group row">
                      <div class="col-sm-6">
                            <app-contact-view [RefId]="RefId"></app-contact-view>
                        </div>
                         <div class="col-sm-6">                          
                            <app-customer-ageing [paymentAgingParam]="paymentAgingParam"></app-customer-ageing>
                       </div>  
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-12">
                            <app-spra-view-data [SPRAId]="SPRAId"></app-spra-view-data>
                        </div>


                    </div>

                    <div class="card-header bg-primary text-left text-white font-weight-bold">
                        SPRA Service Details
                    </div>
                    <div class="card-body mat-card">
                        <!-- <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group row text-left">
                                    <label for="lblLocation" class="col-sm-4 col-form-label">Location <span
                                            class="font-red-flamingo">*</span></label>
                                    <div class="col-sm-8">
                                        <select id="ddlLocation" name="ddlLocation" class="form-control" [(ngModel)]="spraReqServiceDetail.Location" >
                                            <option value="0" selected="true">--Select--</option>
                                            <option value="Remote">Remote</option>
                                            <option value="Metro">Metro</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group row text-left">
                                    <label for="lblDistance" class="col-sm-4 col-form-label">Distance From Service
                                        Center<span class="font-red-flamingo">*</span></label>
                                    <div class="col-sm-8">
                                        <select id="ddlDistance" #Distance name="ddlDistance" [(ngModel)]="spraReqServiceDetail.Distance" class="form-control"  (ngModelChange)="changeDistance(Distance.value,button,ASPbutton)">
                                            <option *ngFor="let ol of DistanceList" value={{ol.id}} >
                                                {{ol.priceListTyp}} </option>
                                        </select> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group row text-left">
                                    <label for="lblServiceBy" class="col-sm-4 col-form-label">Service By<span
                                            class="font-red-flamingo">*</span></label>
                                    <div class="col-sm-8">
                                        <mat-radio-button #button type="radio" id="rdSharp" name="filterType" value="Sharp"
                                           [checked]="true"  (click)="checkState(button,ASPbutton)">
                                            Sharp
                                        </mat-radio-button> 

                                        <mat-radio-button #ASPbutton type="radio" id="rdASP" name="filterType" value="ASP" (click)="checkState(button,ASPbutton)">
                                            ASP
                                        </mat-radio-button>
                                    </div>
                                </div>

                            </div>

                        </div> -->
                        <div class="row">
                            <table class="table ">
                                <thead>
                                    <tr>
                                        <!-- <th>SrNo.</th> -->
                                        <th class="w-10">Consignee Code</th>
                                        <th class="w-30">Consignee Address</th>
                                        <th class="w-10">Contact Person</th>
                                        <th class="w-10"> Service Office </th>
                                        <th class="w-10">Location</th>
                                        <th class="w-10">Distance From Service Center</th>
                                        <th class="w-10">Service By</th>
                                        <th class="w-10">ASP</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let item of ConsigneeDetail; let i = index;">
                                        <tr>
                                            <!-- <td>
                                                {{i+1}}
                                            </td> -->
                                            <td>
                                                {{item.ConsigneeAddrCode}}
                                            </td>
                                            <td>
                                                {{item.ConsigneeAddress}}
                                            </td>
                                            <td>
                                                {{item.ContactPerson}}
                                            </td>
                                            <td>
                                                {{item.OfficeDesc}}                                                
                                            </td>
                                            <td>
                                                <select id="ddlLocation" name="ddlLocation" class="form-control" [(ngModel)]="item.Location" >
                                                    <option value="0" selected="true">--Select--</option>
                                                    <option value="Remote">Remote</option>
                                                    <option value="Metro">Metro</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select id="ddlDistance" #Distance name="ddlDistance" [(ngModel)]="item.Distance" class="form-control"  (ngModelChange)="changeDistance(item)">
                                                    <option *ngFor="let ol of DistanceList" value={{ol.id}} >
                                                        {{ol.priceListTyp}} </option>
                                                </select> 
                                            </td>
                                            <td>
                                                <mat-radio-group [(ngModel)]="item.ServiceBy" name="{{i}}ServiceByGrp">                                                      
                                                    <mat-radio-button value="Sharp"  class="pr-2" name="{{i}}rdSharp" disabled="true">  
                                                        Sharp  
                                                    </mat-radio-button>   
                                                    <mat-radio-button value="ASP" name="{{i}}rdASP" disabled="true">  
                                                        ASP  
                                                    </mat-radio-button> 
                                               </mat-radio-group>  
                                            </td>
                                            <td>
                                                <select id="ddlDealer" name="{{i}}ddlDealer" [(ngModel)]="item.ASPId"  class="form-control" [disabled]="item.ServiceBy == 'Sharp' ">
                                                    <option *ngFor="let ol of item.DealerList" value={{ol.partnerId}} >
                                                        {{ol.partnerName}} </option>
                                                </select> 
                                            </td>
                                        </tr>                                    
                                    </ng-container>
            
                                </tbody>
                            </table>
            
                        </div>
                        <div class="row" >
                            <div class="col-sm-3 ">Remarks</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8">
                                <textarea class="form-control h-50" matInput  maxlength="2000" 
                                [(ngModel)]="spraReqServiceDetail.Mssg" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" name="Msg"
                                ></textarea>
                            </div>
                            <div class="col-sm-4">Action</div>
                            <div class="col-sm-8 pt-2">
                                <mat-radio-group  [(ngModel)]="spraReqServiceDetail.ApvStatus" name="ApvStatus">
                                    <mat-radio-button value="A" class="pr-2"  >Approved</mat-radio-button>
                                    <mat-radio-button value="R">Reject</mat-radio-button>
                                  </mat-radio-group>
                            
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="card-footer text-left">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group row">
                        <div class="col-sm-4"></div>
                        <div class="col-sm-8 pl-4">
                            <button class="btn btn-primary"  [disabled]="DisableSubmit" (click)="SpraSubmit()" >Submit</button>  
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</form>